import AppContainer from './Dashboard';
import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { frontendURL } from '../../helper/URLHelper';
// d99d
import { routes as dstudioRoutes } from './dstudio/routes';
import docalRoutes from './docal/docal.routes';
import { routes as builderRoutes } from './builder/routes';
import { routes as formsRoutes } from './forms/routes';
import integrations from './settings/integrations/OnlineCubedView/integrations.routes';
import dynamicContentRoutes from './dynamicContent/dynamicContent.routes'
// .
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import fileStorageRoutes from './fileStorage/index.routes';
const Suspended = () => import('./suspended/Index');

export default {
  routes: [
    //...helpcenterRoutes.routes,
    {
      path: frontendURL('accounts/:account_id'),
      component: AppContainer,
      children: [
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        // d99d
        ...dstudioRoutes,
        ...docalRoutes.routes,
        ...builderRoutes,
        ...formsRoutes,
        ...integrations.routes,
        ...dynamicContentRoutes,
        ...fileStorageRoutes
        // .
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      roles: ['administrator', 'agent'],
      component: Suspended,
    },
  ],
};
